import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
// Import only needed Swiper CSS
import "swiper/css";
import "swiper/css/navigation";
import "./HeroSection.css";

import background from "./images/dodo12.jpg";

import before1 from "./assets/before1.jpg";
import after1 from "./assets/after1.jpg";
import before2 from "./assets/before2.jpg";
import after2 from "./assets/after2.jpg";
import before3 from "./assets/before3.jpg";
import after3 from "./assets/after3.jpg";
import before4 from "./assets/before4.jpg";
import after4 from "./assets/after4.jpg";
import before5 from "./assets/before5.jpg";
import after5 from "./assets/after5.jpg";
import before6 from "./assets/before6.jpg";
import after6 from "./assets/after6.jpg";

import rusenjeBefore from "./assets/rusenje_before.jpg";
import rusenjeAfter from "./assets/rusenje_after.jpg";
import kosnjaBefore from "./assets/kosnja_before.jpg";
import kosnjaAfter from "./assets/kosnja_after.jpg";
import maslinaBefore from "./assets/maslina_before.jpg";
import maslinaAfter from "./assets/maslina_after.jpg";
import rusenjeBefore2 from "./assets/rusenje_before2.jpg";
import rusenjeAfter2 from "./assets/rusenje_after2.jpg";
import staticAfterRusenje1 from "./assets/rusenjestatic.jpg";
import staticAfterRusenje2 from "./assets/rusenjestatic2.jpg";
import extraImg1 from "./assets/extra1.jpg";
import extraImg2 from "./assets/extra2.jpg";
import extraImg3 from "./assets/kosnja_before.jpg";
import extraImg4 from "./assets/kosnja_after.jpg";

const uredenjePairs = [
  { before: before1, after: after1 },
  { before: before2, after: after2 },
  { before: before3, after: after3 },
  { before: before4, after: after4 },
  { before: before5, after: after5 },
  { before: before6, after: after6 },
];

const rusenjaPairs = [
  { before: rusenjeBefore, after: rusenjeAfter },
  { before: rusenjeBefore2, after: rusenjeAfter2 },
];

// Reusable Swiper Component
function SwiperSection({ title, pairs }) {
  return (
    <>
      <h2 className="hero-title">{title}</h2>
      <Swiper
        modules={[Navigation, Autoplay]}
        navigation
        autoplay={{ 
          delay: 5000, 
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        }}
        spaceBetween={50}
        slidesPerView={1}
        className="before-after-swiper"
        loop={pairs.length > 1}
        lazy={true}
        watchSlidesProgress={true}
      >
        {pairs.map((pair, index) => (
          <SwiperSlide key={index}>
            <div className="slide-pair">
              <div className="image-box">
                <img 
                  src={pair.before} 
                  alt={`${title} - Prije ${index + 1}`}
                  loading="lazy"
                  decoding="async"
                  width="600"
                  height="750"
                  style={{ aspectRatio: '600/750' }}
                />
                <span className="label" aria-hidden="true">Prije</span>
              </div>
              <div className="image-box">
                <img 
                  src={pair.after} 
                  alt={`${title} - Poslije ${index + 1}`}
                  loading="lazy"
                  decoding="async"
                  width="600"
                  height="750"
                  style={{ aspectRatio: '600/750' }}
                />
                <span className="label" aria-hidden="true">Poslije</span>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}

// Main Component
export function HeroSection() {
  return (
    <section
      className="hero-wrapper"
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        position: "relative",
      }}
      aria-label="Hero section with before and after galleries"
    >
      <div className="overlay" />
      <h1 className="hero-main-title">Dodo uređenje</h1>

      <SwiperSection title="Krčenje terena" pairs={uredenjePairs} />
      <SwiperSection title="Rušenje drveća" pairs={rusenjaPairs} />

      <div className="static-image-row">
        <img
          src={staticAfterRusenje1}
          alt="Rušenje visokog drveća - rezultat 1"
          className="static-image"
          loading="lazy"
          decoding="async"
          width="550"
          height="850"
          style={{ aspectRatio: '550/850' }}
        />
        <img
          src={staticAfterRusenje2}
          alt="Rušenje visokog drveća - rezultat 2"
          className="static-image"
          loading="lazy"
          decoding="async"
          width="550"
          height="850"
          style={{ aspectRatio: '550/850' }}
        />
      </div>

      <h2 className="hero-title">Košnja</h2>
      <div className="static-image-row">
        <img 
          src={extraImg3} 
          alt="Košnja trave - prije" 
          className="static-image"
          loading="lazy"
          decoding="async"
          width="550"
          height="850"
          style={{ aspectRatio: '550/850' }}
        />
        <img 
          src={extraImg4} 
          alt="Košnja trave - poslije" 
          className="static-image"
          loading="lazy"
          decoding="async"
          width="550"
          height="850"
          style={{ aspectRatio: '550/850' }}
        />
        <img 
          src={extraImg1} 
          alt="Košnja trave - dodatni radovi 1" 
          className="static-image"
          loading="lazy"
          decoding="async"
          width="550"
          height="850"
          style={{ aspectRatio: '550/850' }}
        />
        <img 
          src={extraImg2} 
          alt="Košnja trave - dodatni radovi 2" 
          className="static-image"
          loading="lazy"
          decoding="async"
          width="550"
          height="850"
          style={{ aspectRatio: '550/850' }}
        />
      </div>

      <h2 className="hero-title">Orezivanje maslina</h2>
      <div className="static-image-row">
        <img 
          src={maslinaBefore} 
          alt="Orezivanje maslina - prije" 
          className="static-image"
          loading="lazy"
          decoding="async"
          width="550"
          height="850"
          style={{ aspectRatio: '550/850' }}
        />
        <img 
          src={maslinaAfter} 
          alt="Orezivanje maslina - poslije" 
          className="static-image"
          loading="lazy"
          decoding="async"
          width="550"
          height="850"
          style={{ aspectRatio: '550/850' }}
        />
      </div>
    </section>
  );
}
